import { respond } from '@fr/rwd';
import { initCarousel } from '@fr/carousel';
import truncate from 'dots';

import './custom_modules/flightsList';


// On document ready
$(function() {

  var $homeCarousel = $('.home-hero__carousel');

  // Home carousel management.
  //
  // 1. Only on xs resolution (`only-xs` in given as value to data-js-mq
  //    attribute), we turn the carousel into a static image.
  // 2. Otherwise we instanciate the carousel.
  // 3. The `data-bubble` value is updated via Javascript and helps us knowing
  //    which image is displayed and then to know which bubble should be
  //    displayed.
  respond($homeCarousel, function() {
    // [1]
    $homeCarousel.find('img:nth(1)').remove();
    $homeCarousel.addClass('home-hero__carousel--visible');
  }, function() {
    // [2]
    $('.home-hero__carousel').attr('data-bubble', 1); // [3]
    $homeCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('.home-hero__carousel').attr('data-bubble', nextSlide+1); // [3]
    });
    initCarousel($homeCarousel);
    $homeCarousel.addClass('home-hero__carousel--visible');
  });


  // Shorten the reviews
  if($('.trustpilot-carousel').length > 0) {
    $('.trustpilot-carousel [itemprop="reviewBody"]').each(function( index ) {
      $(this).text(truncate($(this).text(), 255));
    });

    // Leave at most 6 items on the trustpilot widget
    var length = $('.trustpilot-carousel .slick-dots li').length;
    // Remove all dots above 6 so that we can't slide further than 6 slides.
    for(var i = 1; i <= length-6; i++) {
      $('.trustpilot-carousel').slick('slickRemove', false);
    }
  }

  if($('.how-it-works').length > 0) {

    // Trick to get trigger the columns adaption for How it works and FAQ
    // on bigger devices.
    respond($('.how-it-works'), function() {
      if($('.how-it-works').outerHeight() < $('.faq').outerHeight()) {
        $('.how-it-works').outerHeight($('.faq').outerHeight());
      } else {
        $('.faq').outerHeight($('.how-it-works').outerHeight());
      }
    });
  }

});
